var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoRedondo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#28BFD7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 121.905,
    y: 357.354,
    width: 273.705,
    height: 20.0272,
    fill: "#010101"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 135.256,
    y: 330.651,
    width: 247.002,
    height: 20.0272,
    fill: "#010101"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 161.96,
    y: 323.975,
    width: 140.19,
    height: 53.4059,
    transform: "rotate(-90 161.96 323.975)",
    fill: "#010101"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 235.393,
    y: 323.975,
    width: 140.19,
    height: 53.4059,
    transform: "rotate(-90 235.393 323.975)",
    fill: "#010101"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 308.824,
    y: 323.975,
    width: 140.19,
    height: 53.4059,
    transform: "rotate(-90 308.824 323.975)",
    fill: "#010101"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M169.231 150.406L141.932 148.812C143.507 133.667 151.119 121.378 164.768 111.946C178.593 102.38 195.217 97.5978 214.641 97.5978C226.016 97.5978 235.903 99.1256 244.302 102.181C252.702 105.237 260.489 108.757 267.664 112.743C274.839 116.595 282.101 120.116 289.451 123.304C296.975 126.36 305.55 127.888 315.174 127.888C326.374 127.888 336.524 125.031 345.623 119.319C354.723 113.473 360.148 106.034 361.898 97L388.934 100.188C386.309 115.201 377.997 127.223 363.997 136.257C350.173 145.291 334.249 149.808 316.224 149.808C304.675 149.808 294.875 148.28 286.826 145.225C278.951 142.169 271.601 138.715 264.777 134.862C257.952 130.877 250.777 127.356 243.252 124.301C235.728 121.112 226.541 119.518 215.691 119.518C203.267 119.518 192.68 122.507 183.93 128.486C175.18 134.331 170.28 141.638 169.231 150.406Z",
    fill: "#010101"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRedondo);
export default __webpack_public_path__ + "static/media/logo_redondo.e2b0660c03463f44abc4b74f861484e3.svg";
export { ForwardRef as ReactComponent };